import { AddressDto } from '../address/address.dto';
import { FileDto } from '../file';
import { PropertyFillInStatusDto } from './property-fill-in-status.dto';
import { PropertyOccupancy } from './property-occupancy.enum';
import { PropertyAcquisitionDocument, PropertyOwnershipDocument } from './property-occupation';
import { PropertySituation } from './property-situation.enum';
import { PropertyUsage } from './property-usage.enum';

export enum ImovelDocumentos {
  PLANTA_DE_ANUENCIA = 'PLANTA_DE_ANUENCIA',
  CROQUI_DE_AVERBACAO = 'CROQUI_DE_AVERBACAO',
};

export type ImovelDocumentosTipo = ImovelDocumentos | PropertyAcquisitionDocument | PropertyOwnershipDocument;

export class PropertyDto {
  id: string;
  projetoFid: string;
  blockId: number;
  quadra: string;
  lotId: number;
  lote: string;
  photoId: string;
  address: AddressDto;
  usage: PropertyUsage;
  specifyUsage: string;
  occupation: PropertyOccupancy;
  situation: PropertySituation;
  specifySituation: string;
  loteArea: number;
  possuiOutroImovel: boolean;
  // residentsQuantity: number;
  // residenceTime: number;
  // housesQuantity: number;
  // housesQuantitySameOwner: number;
  // entriesQuantity: number;
  // entriesQuantitySamePavement: number;
  createdAt: string;
  updatedAt: string;
  files: FileDto[]
  fillInStatus: PropertyFillInStatusDto;
}
